import TextField from '@/common/components/TextField'
import { formatUnit } from '@/common/utils/formatters'
import { secondsToInterval } from '@/common/utils/secondsToInterval'
import { RestrictionData } from '@/features/company/types/company.type'
import { CalendarDaysIcon, ClockIcon } from 'lucide-react'

export const BranchConsumptionRestriction = ({ restriction }: { restriction?: RestrictionData }) => {
  const minimumSecondsIntervalBetweenConsumptions = secondsToInterval(
    restriction?.minimum_seconds_interval_between_consumptions || 0,
  )
  const minimumKilometersUsageBetweenConsumptions = restriction?.minimum_kilometers_usage_between_consumptions
    ? formatUnit(restriction?.minimum_kilometers_usage_between_consumptions, 'kilometers')
    : ''
  const maximumKilometersUsageBetweenConsumptions = restriction?.maximum_kilometers_usage_between_consumptions
    ? formatUnit(restriction?.maximum_kilometers_usage_between_consumptions, 'kilometers')
    : ''
  const minimumSecondsUsageBetweenConsumptions = secondsToInterval(
    restriction?.minimum_seconds_usage_between_consumptions || 0,
  )
  const maximumSecondsUsageBetweenConsumptions = secondsToInterval(
    restriction?.maximum_seconds_usage_between_consumptions || 0,
  )

  return (
    <div className="flex flex-col gap-y-4">
      <div className="flex items-center gap-x-2">
        <p className="text-[0.6875rem] leading-3">Intervalo de tempo mínimo entre consumos:</p>

        <div className="flex h-full items-center gap-x-3">
          <div className="flex items-center gap-x-2">
            <CalendarDaysIcon strokeWidth={1} className="size-5" />

            <div className="flex flex-col items-start justify-center gap-y-0.5">
              <p className="text-[0.625rem] leading-3 font-light italic">Dias</p>

              <p
                data-testid="minimum_seconds_interval_between_consumptions_days"
                className="text-xs font-bold text-white-800"
              >
                {minimumSecondsIntervalBetweenConsumptions.days}
              </p>
            </div>
          </div>

          <div className="h-6 w-px bg-white-300" />

          <div className="flex items-center gap-x-2">
            <ClockIcon strokeWidth={1} className="size-5" />

            <div className="flex flex-col items-start justify-center gap-y-0.5">
              <p className="text-[0.625rem] leading-3 font-light italic">Horas:Minutos:Segundos</p>

              <p
                data-testid="minimum_seconds_interval_between_consumptions_time"
                className="text-xs font-bold text-white-800"
              >
                {minimumSecondsIntervalBetweenConsumptions.hours}:{minimumSecondsIntervalBetweenConsumptions.minutes}:
                {minimumSecondsIntervalBetweenConsumptions.seconds}
              </p>
            </div>
          </div>
        </div>
      </div>

      <TextField
        data-testid="minimum_kilometers_usage_between_consumptions_input"
        label="Intervalo Mínimo de Quilometragem entre consumos"
        value={minimumKilometersUsageBetweenConsumptions}
        disabled
      />

      <TextField
        data-testid="maximum_kilometers_usage_between_consumptions_input"
        label="Intervalo Máximo de Quilometragem entre consumos"
        value={maximumKilometersUsageBetweenConsumptions}
        disabled
      />

      <div className="flex items-center gap-x-2">
        <p className="text-[0.6875rem] leading-3">Intervalo mínimo de Hora-Uso entre consumos:</p>

        <div className="flex h-full items-center gap-x-3">
          <div className="flex items-center gap-x-2">
            <CalendarDaysIcon strokeWidth={1} className="size-5" />

            <div className="flex flex-col items-start justify-center gap-y-0.5">
              <p className="text-[0.625rem] leading-3 font-light italic">Dias</p>

              <p
                data-testid="minimum_seconds_usage_between_consumptions_days"
                className="text-xs font-bold text-white-800"
              >
                {minimumSecondsUsageBetweenConsumptions.days}
              </p>
            </div>
          </div>

          <div className="h-6 w-px bg-white-300" />

          <div className="flex items-center gap-x-2">
            <ClockIcon strokeWidth={1} className="size-5" />

            <div className="flex flex-col items-start justify-center gap-y-0.5">
              <p className="text-[0.625rem] leading-3 font-light italic">Horas:Minutos:Segundos</p>

              <p
                data-testid="minimum_seconds_usage_between_consumptions_time"
                className="text-xs font-bold text-white-800"
              >
                {minimumSecondsUsageBetweenConsumptions.hours}:{minimumSecondsUsageBetweenConsumptions.minutes}:
                {minimumSecondsUsageBetweenConsumptions.seconds}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-x-2">
        <p className="text-[0.6875rem] leading-3">Intervalo máximo de Hora-Uso entre consumos:</p>

        <div className="flex h-full items-center gap-x-3">
          <div className="flex items-center gap-x-2">
            <CalendarDaysIcon strokeWidth={1} className="size-5" />

            <div className="flex flex-col items-start justify-center gap-y-0.5">
              <p className="text-[0.625rem] leading-3 font-light italic">Dias</p>

              <p
                data-testid="minimum_seconds_usage_between_consumptions_days"
                className="text-xs font-bold text-white-800"
              >
                {maximumSecondsUsageBetweenConsumptions.days}
              </p>
            </div>
          </div>

          <div className="h-6 w-px bg-white-300" />

          <div className="flex items-center gap-x-2">
            <ClockIcon strokeWidth={1} className="size-5" />

            <div className="flex flex-col items-start justify-center gap-y-0.5">
              <p className="text-[0.625rem] leading-3 font-light italic">Horas:Minutos:Segundos</p>

              <p
                data-testid="minimum_seconds_usage_between_consumptions_time"
                className="text-xs font-bold text-white-800"
              >
                {maximumSecondsUsageBetweenConsumptions.hours}:{maximumSecondsUsageBetweenConsumptions.minutes}:
                {maximumSecondsUsageBetweenConsumptions.seconds}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
